import { configure, makeAutoObservable } from "mobx";
import io from "socket.io-client";
import * as twitch from "../utils/twitch";
configure({
  enforceActions: "observed",
});

class OverlayStore {
  broadcaster_id = "";
  campaign = {};
  campaignID = 0;
  campaignName = "";
  cause = "";
  counter = 0;
  donations = [];
  error = null;
  exactPercent = 0;
  goal = 0;
  goalVal = 0;
  gtgGoal = 0;
  gtgPercent = 0;
  gtgProgress = 0;
  isLoading = false;
  milestones = [];
  milestoneSort = [];
  minutes = 0;
  percent = 0;
  poll = [];
  pollOptions = [];
  pollId = 0;
  pollName = "";
  polls = [];
  pollID = 0;
  progress = 0;
  raised = 0;
  raisedVal = 0;
  remaining = "0";
  remainingVal = 0;
  rewards = [];
  rewardSort = [];
  seconds = 0;
  slug = "";

  socket = null;
  twitchSessionID = "";
  status = "";
  streamType = "";
  targets = [];
  targetsSort = [];
  teamRaised = 0;
  teampercent = 0;
  teamprogress = 0;
  username = "";
  mLeft = 0;
  fake = false;

  constructor() {
    makeAutoObservable(this);
  }

  socketDisconnect() {
    if (this.socket.disconnect) this.socket.disconnect();
    else this.socket.close();
  }

  socketConnect(streamType, username, slug, pollID, fake = false) {
    this.setIsLoading(true);
    this.setUserInfo(username, streamType, slug);
    this.setPollInfo(pollID);
    this.setFake(fake);

    this.socket = io(process.env.REACT_APP_SERVICE_URI, {
      query: `type=${this.streamType}&username=${this.username}&slug=${this.slug}&fake=${this.fake}&pollID=${this.pollID}`,
      withCredentials: false,
    });

    this.socket.on("error", (error) => {
      console.log("error", error);
      this.setError(error);
    });

    this.socket.on("connect_error", (error) => {
      console.log("connect_error", error);
      this.setError(error);
    });

    this.socket.on("user", (data) => {
      // "User" is a misnomer. The data received is a campaign.
      const campaign = data;
      this.setCampaign(campaign);
      this.setError(false);

      this.socket.on("active", (data) => {
        // "Active" is a misnomer. The data received is a campaign.
        const campaign = data;
        this.setError(false);

        this.setStatus(campaign.status);
        this.setCause(campaign.cause_id);
        this.campaignName = campaign.name;
      });

      this.socket.on("donations", (data) => {
        this.setError(false);
        const donations = data;
        this.setDonations(donations);
      });

      this.socket.on("milestones", (data) => {
        this.setError(false);
        const milestones = data;
        this.setMilestones(milestones);
      });

      this.socket.on("polls", (data) => {
        const polls = data;
        this.setPolls(polls);
      });

      this.socket.on("poll", (data) => {
        const poll = data.data;
        if (poll) {
          const pollName = poll.name;
          const pollID = poll.id;
          const pollOpions = poll.options;
          this.setPoll(poll, pollName, pollID, pollOpions);
        }
      });

      this.socket.on("rewards", (data) => {
        this.setError(false);
        const rewards = data;
        this.setRewards(rewards);
      });

      this.socket.on("targets", (data) => {
        this.setError(false);
        const targets = data;
        this.setTargets(targets);
      });

      this.socket.on("totals", (data) => {
        const campaign = data;
        this.setCampaign(campaign);

        const numRaised = Number(campaign.amount_raised.value);
        const numGoal = Number(campaign.goal.value);
        const teamNumRaised = Number(campaign.total_amount_raised.value);
        this.setTotals(numRaised, numGoal, teamNumRaised);

        this.setIsLoading(false);
      });

      this.socket.emit("getData", this.campaign);
      this.setIsLoading(false);
    });
  }

  setCampaign = (campaign) => {
    this.campaign = campaign;
  };

  setCampaignID = (campaignID) => {
    this.campaignID = campaignID;
  };

  setCause = (cause) => {
    this.cause = cause;
    console.log("store", cause);
  };

  setDonations = (donations) => {
    this.donations = donations;
    const calcSpeed = (speed) => {
      // Time = Distance/Speed
      let spanSelector = document.querySelectorAll(".marquee-wrap .scroller"),
        i;
      for (i = 0; i < spanSelector.length; i++) {
        const spanLength = spanSelector[i].offsetWidth,
          timeTaken = spanLength / speed;
        spanSelector[i].style.animationDuration = timeTaken + "s";
      }
    };
    calcSpeed(40);
  };

  setError = (error) => {
    this.error = error;
  };

  setIsLoading = (boolean) => {
    this.isLoading = boolean;
  };

  setMilestones = (milestones) => {
    this.milestones = milestones;
    const mWidth = () => {
      let spanSelector = document.querySelectorAll(".milestone-amount"),
        i;
      for (i = 0; i < spanSelector.length; i++) {
        const spanLength = spanSelector[i].offsetWidth;
        spanSelector[i].style.left = "-" + spanLength + "px";
      }
    };
    this.mLeft = mWidth();

    this.milestoneSort = milestones
      .slice()
      .sort((a, b) => Number(a.amount.value) - Number(b.amount.value));
  };

  setPolls = (polls) => {
    this.polls = polls;
  };

  setPoll = (poll, pollName, pollID, pollOpions) => {
    this.poll = poll;
    this.pollName = pollName;
    this.pollID = pollID;
    this.pollOptions = pollOpions;
  };

  setRewards = (rewards) => {
    this.rewards = rewards;

    this.rewardSort = rewards
      .slice()
      .sort((a, b) => Number(a.amount.value) - Number(b.amount.value));
  };

  setStatus = (status) => {
    this.status = status;
  };

  setTargets = (targets) => {
    this.targets = targets;

    this.targetsSort = targets
      .slice()
      .sort((a, b) => Number(a.amount.value) - Number(b.amount.value));
  };

  setTotals = (raised, goal, teamRaised) => {
    this.raised = this.streamType === "@" ? raised : teamRaised;
    this.goal = goal;

    const formatNumber = (num) => {
      let value = num;
      const res = String(num).split(".");
      if (res.length === 1 || res[1].length <= 3) {
        value = value
          .toFixed(2)
          .replace(/\.00$/, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      return value;
    };

    this.raisedVal = formatNumber(raised);
    this.goalVal = formatNumber(goal);

    this.percent = Math.floor(
      100 *
        (parseFloat(this.streamType === "@" ? raised : teamRaised) /
          parseFloat(goal))
    );

    this.exactPercent = Number(100 * (Number(raised) / Number(goal)));
    this.progress = this.percent > 100 ? 100 : this.percent;
    this.remaining = (this.goal - this.raised).toFixed(2);
    this.remainingVal = formatNumber(Number(this.remaining));

    {
      this.goal >= 5000
        ? (this.gtgGoal = 5000)
        : this.goal >= 2000
        ? (this.gtgGoal = 2000)
        : this.goal >= 1000
        ? (this.gtgGoal = 1000)
        : 0;
    }

    this.gtgPercent = Math.round(
      100 * (parseFloat(this.raised) / parseFloat(this.gtgGoal))
    );

    this.gtgProgress = this.gtgPercent > 100 ? 100 : this.gtgPercent;
  };

  setPollInfo = (pollID) => {
    this.pollID = pollID;
  };

  setUserInfo = (user, streamType, slug) => {
    this.slug = slug;
    this.streamType = streamType;
    // this.pollID = pollID;

    if (streamType === "@" || streamType === "+") {
      this.username = user;
    } else {
      this.broadcaster_id = user;
    }
  };

  setFake = (fake) => {
    this.fake = fake;
  };

  twitchSocketConnect(twitchOAuthToken) {
    twitch.setTwitchOAuthToken(twitchOAuthToken);
    this.setIsLoading(true);
    const t = this;
    async function connect() {
      const reconnectInterval = 1000 * 3;
      t.socket = new WebSocket("wss://eventsub.wss.twitch.tv/ws");
      t.socket.onerror = (error) => {
        console.log("error", error);
        t.setError(error);
      };

      t.socket.onmessage = function (event) {
        const message = JSON.parse(event.data);

        /* const d = {
          "metadata": {
            "message_id": "2c756df3-cafe-427f-845b-bfc57ab55b26", "message_type": "session_welcome", "message_timestamp": "2024-03-14T20:22:51.259228532Z"
          },
          "payload": {
            "session": {
              "id": "AgoQKtlDZjBUSPiv3HJq-zB5PhIGY2VsbC1i", "status": "connected", "connected_at": "2024-03-14T20:22:51.250438393Z", "keepalive_timeout_seconds": 10, "reconnect_url": null
            }
          }
        } */
        const { message_type } = message.metadata;
        switch (message_type) {
          case "session_welcome":
            t.twitchSessionID = message.payload.session.id;
            twitch.resubscribeAll(t.twitchSessionID, t.broadcaster_id);
            break;
          case "notification":
            const subtype = message.payload.subscription.type;
            const { event } = message.payload;
            console.log("twitch notification", message);
            switch (subtype) {
              case "channel.charity_campaign.donate":
                t.donations.push(event);
                break;
              case "channel.charity_campaign.progress":
                t.setTwitchTotals(
                  twitch.currencyToAmount(event.current_amount),
                  twitch.currencyToAmount(event.target_amount),
                  twitch.currencyToAmount(event.current_amount)
                );
                break;
            }

            break;
          case "session_reconnect":
            const url = message.payload.session.reconnect_url;
            t.socket.close();
            t.socket = new WebSocket(url);
            break;
        }
      };
      t.socket.onclose = function (e) {
        //auto reconnect after a few seconds
        setTimeout(connect, reconnectInterval);
      };

      try {
        const userData = await twitch.getUserData();
        t.setUserInfo(userData.id, "twitch", userData.login);
        const campData = await twitch.getCharityCamps(t.broadcaster_id);
        //TODO determine if we need to filter this or something
        if (campData.length > 0) {
          const data = campData[0];
          t.setCause(data.charity_name);
          t.setStatus("published");
          t.setCampaign(data);
          t.setCampaignID(data.id);
          console.log(
            "Setting twitch totals",
            twitch.currencyToAmount(data.current_amount),
            twitch.currencyToAmount(data.target_amount),
            twitch.currencyToAmount(data.current_amount)
          );
          t.setTwitchTotals(
            twitch.currencyToAmount(data.current_amount),
            twitch.currencyToAmount(data.target_amount),
            twitch.currencyToAmount(data.current_amount)
          );
          t.setIsLoading(false);
        }
        const donoData = await twitch.getHistoricalDonations(t.broadcaster_id);
        t.setDonations(donoData.data);
      } catch (e) {
        console.error(e);
      }
    }
    connect();

    this.setIsLoading(false);
  }

  updateTwitchSocketQuery(
    type,
    broadcaster_id,
    access_token,
    refresh_token,
    exp_timestamp,
    slug
  ) {
    this.socket.io.opts.query = `type=${type}&broadcaster_id=${broadcaster_id}&access_token=${access_token}&refresh_token=${refresh_token}&exp_timestamp=${exp_timestamp}&slug=${slug}`;
    this.socket.query = `type=${type}&broadcaster_id=${broadcaster_id}&access_token=${access_token}&refresh_token=${refresh_token}&exp_timestamp=${exp_timestamp}&slug=${slug}`;
    this.socket.io.engine.opts.query.access_token = access_token;

    //this.socket.disconnect().connect();
    this.socket.emit("refreshTwitch");
  }

  setTwitchTotals = (raised, goal, teamRaised) => {
    this.raised = raised;
    if(goal>this.goal&&goal!=0){
      this.goal = goal;
      this.goalVal = goal; //formatNumber(goal.toString());
    }
    this.teamRaised = teamRaised;

    const formatNumber = (num) => {
      return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };

    this.raisedVal = raised; //formatNumber(raised.toString());
    

    this.percent = Math.round(100 * (raised / this.goal));

    this.exactPercent = Number(100 * (raised / this.goal));

    // this.teampercent = Math.round(
    //   100 * (parseFloat(this.teamRaised) / parseFloat(this.goal))
    // );

    this.progress = this.percent > 100 ? 100 : this.percent;
    this.teamprogress = this.teampercent > 100 ? 100 : this.teampercent;

    this.remaining = (this.goal - raised).toFixed(2);
    this.remainingVal = formatNumber(this.remaining);

    // GTG OVERLAY

    {
      this.goal >= 5000
        ? (this.gtgGoal = 5000)
        : this.goal >= 2000
        ? (this.gtgGoal = 2000)
        : this.goal >= 1000
        ? (this.gtgGoal = 1000)
        : 0;
    }

    // console.log('goal', this.gtgGoal)

    this.gtgPercent = Math.round(
      100 * (parseFloat(raised) / parseFloat(this.gtgGoal))
    );
    this.gtgProgress = this.gtgPercent > 100 ? 100 : this.gtgPercent;
  };
}

export default new OverlayStore();
